module.exports = __webpack_public_path__ + "img/hr-level3addon_idle_shadow.79a97fba.png";